import React, { useState, useEffect } from 'react';
import { format, startOfDay, subDays } from 'date-fns';
import { useSearchParams } from 'react-router-dom';
import { Menu } from '@mui/material';
import CalendarPicker from './CalendarPicker';

export default function DatePick({ selectDate, defaultDates }) {
    const today = new Date();
    const [anchorEl, setAnchorEl] = useState(null);
    const [dates, setDates] = useState({ startDate: startOfDay(subDays(today, 8)), endDate: startOfDay(subDays(today, 1)) })

    const handleCustomPickClose = (s, label) => {
        if (label === "start") {
            setDates(cur => ({ ...cur, startDate: s }))
        } else if (label === "end") {
            setDates(cur => ({ ...cur, endDate: s }))
        }
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const applyFilters = () => {
        selectDate({ d1: new Date(dates.startDate), d2: new Date(dates.endDate) })
        setAnchorEl(null)
        //Submit the new filters 
    }

    return (
        <div>
            <button onClick={handleClick} style={{
                width: 'max-content', fontSize: '.75rem', borderRadius: '5px',
                border: 'none', background: 'none', padding: '5px 10px',
                fontWeight: '550',
                boxShadow: "0rem -.0625rem 0rem 0rem #b5b5b5 inset, 0rem 0rem 0rem .0625rem rgba(0, 0, 0, .1) inset, 0rem .03125rem 0rem .09375rem #FFF inset"
            }}>
                {`${format(new Date(dates.startDate), 'MMM d, yyyy')} - ${format(new Date(dates.endDate), 'MMM d, yyyy')}`}
            </button>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                sx={{ padding: '0 10px' }}
            >
                <div className="row m-0 p-0">
                    {/* Left column: preset options */}

                    {/* show menu options for the regular date menu dropdown */}

                    <div className="col-6 border-start" style={{ marginTop: '8px' }}>
                        <CalendarPicker curDates={{ s: dates.startDate }} handleClose={(f) => handleCustomPickClose(f, "start")} label={"From"} />
                    </div>
                    <div className="col-6 border-start" style={{ marginTop: '8px' }}>
                        <CalendarPicker curDates={{ s: dates.endDate }} handleClose={(f) => handleCustomPickClose(f, "end")} label={"To"} />
                    </div>
                </div>

                <div className='row m-0' style={{ justifyContent: 'end', padding: '10px 10px 0 0' }}>
                    <button
                        onClick={applyFilters}
                        className='submit'
                        style={{ width: '100px', height: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >Apply</button>
                </div>
            </Menu>
        </div>
    );
};
